<template>
  <v-container app :fluid="true" class="pt-0">
    <v-row>
      <v-col cols="6">
        <v-text-field v-model="search" append-icon="fas fa-search" label="Buscar cliente" solo dense hide-details></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-btn @click="showCreateCustomer()" rised color="indigo" dark class="float-right wost-btn-new" v-if="verifyPermission('crear_clientes')">
          <v-icon dark left size="12">fas fa-plus</v-icon>Nuevo Cliente
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="10" class="pt-0">
        <v-card>
          <v-data-table
            class="wost-table"
            :headers="headers"
            :items="customers"
            item-key="id"
            show-expand
            :search="search"
            :single-expand="true"
            :fixed-header="false"
            height="65vh"
            @click:row="handleCurrentChange"
            v-if="verifyPermission('listar_clientes')"
            no-data-text=""
          >
            <template v-slot:item.name="{ item }">
              <span v-if="item.type_document === 'DNI'">{{ item.name + " " + item.surname }}</span>
              <span v-else>{{ item.name }}</span>
              <span :class="'status-' + item.status.toLowerCase()">{{ item.status }}</span>
            </template>
            <!--
                            <template v-slot:item.rating="{ item }">
                                <div>
                                    <v-icon size="16" :class="'rating ' + item.clasification">fas fa-star</v-icon>
                                    <span style="margin-left: 10px">{{ item.rating }}</span>
                                </div>                                
                            </template>
                            -->

            <template v-slot:item.action="{ item }">
              <div class="datatable-cell-wrapper">
                <a href="#" title="Editar" class="btn-actions btn-edit" @click="editCustomer(item)" v-if="verifyPermission('actualizar_clientes')">
                  <v-icon color="amber" size="16">fas fa-pencil-alt</v-icon>
                </a>
                &nbsp;
                <a
                  v-if="item.status.toLowerCase() === 'activo' && verifyPermission('inactivar_clientes')"
                  href="#"
                  title="Inactivar"
                  class="btn-actions btn-delete"
                  @click="changeStatus(item, 'inactivar')"
                >
                  <v-icon color="red darken-1" size="16">fas fa-minus-circle</v-icon>
                </a>
                <a
                  v-else-if="item.status.toLowerCase() === 'inactivo' && verifyPermission('activar_clientes')"
                  href="#"
                  title="Activar"
                  class="btn-actions btn-delete"
                  @click="changeStatus(item, 'activar')"
                >
                  <v-icon color="green darken-1" size="16">fas fa-check-circle</v-icon>
                </a>
              </div>
            </template>
            <template v-slot:expanded-item="{ item, headers }">
              <td :colspan="headers.length" class="wost-td-expanded">
                <CustomerDetail :customer="item" :orders="item.orders"></CustomerDetail>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col cols="2" class="pt-0">
        <v-card height="72vh" color="#f9f8ff">
          <v-card-title>
            <div class="stadistic-title">
              <span>RESUMEN</span>
            </div>
          </v-card-title>
          <v-card-text>
            <div class="stadistic-item">
              <span class="stadistic stadistic-item-title">Total de pedidos</span>
              <span class="stadistic stadistic-item-number">
                {{ currentStadistic.total_orders }}
              </span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- +++++++++ formulario nuevo cliente +++++++++++++++++++++ -->
    <v-navigation-drawer v-model="drawer" width="750" app temporary right class="wost-drawer">
      <div class="form-head">
        {{ titleForm }}
      </div>
      <div class="wrapper-form-crud overflow-y-auto">
        <v-form>
          <v-container :fluid="true" class="pt-0">
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-text>
                    <v-container v-if="isNatural">
                      <v-row>
                        <v-col :cols="6">
                          <v-select
                            v-model="formCustomer.type"
                            outlined
                            dense
                            :items="typesCustomers"
                            label="Tipo"
                            @change="handleChangeSelect"
                            hide-details
                          ></v-select>
                        </v-col>
                        <v-col :cols="5">
                          <v-text-field
                            v-model="formCustomer.document"
                            ref="document"
                            label="DNI"
                            outlined
                            dense
                            type="number"
                            :rules="[() => !!formCustomer.document || 'Debe ingresar número de documento']"
                            hide-details="auto"
                            required
                            :loading="searching_document"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="1" class="pl-0">
                          <v-icon class="mt-2" @click="handleSearchDocument">
                            fas fa-search
                          </v-icon>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col :cols="6">
                          <v-text-field
                            v-model="formCustomer.name"
                            ref="name"
                            label="Nombres"
                            outlined
                            dense
                            :rules="[() => !!formCustomer.name || 'Es necesario ingresar un nombre']"
                            hide-details="auto"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col :cols="6">
                          <v-text-field v-model="formCustomer.surname" label="Apelidos" outlined dense hide-details></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col :cols="6">
                          <v-select v-model="formCustomer.gender" :items="genders" label="Genero" outlined dense hide-details></v-select>
                        </v-col>
                        <v-col :cols="6">
                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="formCustomer.birthdate"
                                label="Fecha de nacimiento"
                                readonly
                                outlined
                                dense
                                v-on="on"
                                hide-details
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="formCustomer.birthdate" @input="menu2 = false" locale="es"></v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col :cols="6">
                          <v-text-field v-model="formCustomer.phone" label="Teléfono" outlined dense hide-details></v-text-field>
                        </v-col>
                        <v-col :cols="6">
                          <v-text-field v-model="formCustomer.email" label="Email" outlined dense hide-details></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col :cols="12">
                          <v-textarea name="input-7-1" label="Dirección" outlined v-model="formCustomer.address" :rows="3" hide-details></v-textarea>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-container v-else>
                      <v-row>
                        <v-col :cols="6">
                          <v-select
                            v-model="formCustomer.type"
                            :items="typesCustomers"
                            label="Tipo"
                            outlined
                            dense
                            @change="handleChangeSelect"
                            hide-details
                          ></v-select>
                        </v-col>
                        <v-col :cols="5">
                          <v-text-field
                            v-model="formCustomer.document"
                            ref="document"
                            label="RUC"
                            outlined
                            dense
                            type="number"
                            :loading="searching_document"
                            :rules="[() => !!formCustomer.document || 'Debe ingresar número de documento']"
                            hide-details="auto"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="1" class="pl-0">
                          <v-icon class="mt-2" @click="handleSearchDocument">
                            fas fa-search
                          </v-icon>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col :cols="6">
                          <v-text-field
                            v-model="formCustomer.name"
                            ref="name"
                            label="Razon Social"
                            outlined
                            dense
                            :rules="[() => !!formCustomer.name || 'Es necesario ingresar razon social']"
                            hide-details="auto"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col :cols="6">
                          <v-text-field v-model="formCustomer.phone" label="Teléfono" outlined dense hide-details></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col :cols="12">
                          <v-text-field v-model="formCustomer.email" label="Email" outlined dense hide-details></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col :cols="12">
                          <v-textarea label="Dirección" v-model="formCustomer.address" :rows="3" outlined dense hide-details></v-textarea>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6"> </v-col>
              <v-col cols="3">
                <v-btn color="error" block dark @click="closeDrawer()" :elevation="10">Cancelar</v-btn>
              </v-col>
              <v-col cols="3">
                <v-btn v-if="actionCrud === 'create'" color="green" block dark @click="addCustomer()" :elevation="10">Guardar</v-btn>

                <v-btn v-else color="blue" block dark @click="updateCustomer()" :elevation="10">Actualizar</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </div>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import { APIService } from "@/APIService";
import CustomerDetail from "./CustomerDetail";

import ApiCustomer from "../../apis/Customer";
import SunatReniecService from "../../services/SunatReniecService";
import APIPERU from "../../apis/Reniec";

import Tools from "../../helpers/Tools";

const apiService = new APIService();

export default {
  name: "newCustomer",
  components: {
    CustomerDetail,
  },
  data() {
    return {
      menu2: false,
      search: "",
      typesCustomers: [
        {
          text: "Jurídico",
          value: "Jurídico",
        },
        {
          text: "Natural",
          value: "Natural",
        },
      ],
      genders: [
        {
          text: "Femenino",
          value: "Femenino",
        },
        {
          text: "Masculino",
          value: "Masculino",
        },
      ],
      districts: [
        {
          text: "Trujillo",
          value: "Trujillo",
        },
        {
          text: "El Porvenir",
          value: "El Porvenir",
        },
      ],
      headers: [
        {
          text: "Tipo",
          value: "type",
          align: "left",
          sortable: false,
          class: "header-table",
          width: 80,
        },
        {
          text: "Nombre",
          value: "name",
          align: "left",
          sortable: false,
          class: "header-table",
        },
        {
          text: "T. Documento",
          value: "type_document",
          align: "left",
          sortable: false,
          class: "header-table",
          width: 140,
        },
        {
          text: "Documento",
          value: "document",
          align: "left",
          sortable: false,
          class: "header-table",
          width: 140,
        },
        {
          text: "Teléfono",
          value: "phone",
          align: "left",
          sortable: false,
          class: "header-table",
          width: 110,
        },
        {
          text: "Acciones",
          value: "action",
          sortable: false,
          class: "header-table text-center",
          width: 90,
        },
        {
          text: "",
          value: "data-table-expand",
          class: "header-table-expand",
          width: 20,
        },
      ],
      isNatural: true,
      drawer: false,
      direction: "rtl",
      titleForm: "Registro de nuevo cliente",
      actionCrud: "create",
      formCustomer: {
        id: null,
        type: "Natural",
        document: null,
        name: null,
        surname: null,
        gender: null,
        birthdate: null,
        phone: null,
        email: null,
        district: null,
        address: null,
        credit_line: null,
        discount: null,
      },
      customers: [],
      orders: [],
      currentRow: null,
      currentStadistic: {
        total_orders: 0,
        total_drums: 0,
        total_balances: 0,
      },
      finded: false,
      viewProduct: false,
      titleProducts: "",
      products: [],
      searching_document: false,
    };
  },
  methods: {
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
    },
    handleCurrentChange(val) {
      this.currentRow = val;
      this.finded = true;
      this.getStadistic(this.currentRow.id);
    },
    getCustomers() {
      apiService.getCustomers().then((data) => {
        this.customers = data.data;
      });
    },
    closeDrawer() {
      this.drawer = false;
      this.clearForm();
    },
    async clearForm() {
      if (this.$refs.formCustomer) {
        this.$refs.formCustomer.resetFields();
      }
      this.formCustomer.id = null;
      this.formCustomer.type = "Natural";
      this.formCustomer.document = null;
      this.formCustomer.name = null;
      this.formCustomer.surname = null;
      this.formCustomer.gender = null;
      this.formCustomer.birthdate = null;
      this.formCustomer.phone = null;
      this.formCustomer.email = null;
      this.formCustomer.district = null;
      this.formCustomer.address = null;
      this.formCustomer.credit_line = null;
      this.formCustomer.discount = null;
      await this.clearErrors();
    },
    showCreateCustomer() {
      this.clearForm();
      this.titleForm = "Registro de nuevo cliente";
      this.actionCrud = "create";
      this.isNatural = true;
      this.drawer = true;
    },
    addCustomer() {
      if (!this.existErrors()) {
        let validDocument = this.validateDocumentNumber(this.formCustomer.type, this.formCustomer.document);
        if (validDocument != "success") {
          this.$notify({
            group: "foo",
            type: "error",
            title: "REGISTRO DE CLIENTE",
            text: validDocument,
          });
        } else {
          apiService
            .createCustomer(this.formCustomer)
            .then((response) => {
              this.customers.push(response.data);
              this.clearForm();
              this.$notify({
                group: "foo",
                type: "success",
                title: "REGISTRO DE CLIENTE",
                text: "Cliente registrado de forma correcta.",
              });
              this.drawer = false;
            })
            .catch(function(error) {
              this.$notify({
                group: "foo",
                type: "error",
                title: "REGISTRO DE CLIENTE",
                text: "Ocurrió un error al registrar cliente.",
              });
            });
        }
      }
    },
    editCustomer(customer) {
      this.clearForm();
      this.setIsNatural(customer.type);
      this.titleForm = "Editar cliente";
      this.actionCrud = "edit";
      this.formCustomer.id = customer.id;
      this.formCustomer.type = customer.type;
      this.formCustomer.document = customer.document;
      this.formCustomer.name = customer.name;
      this.formCustomer.surname = customer.surname;
      this.formCustomer.gender = customer.gender;
      if (customer.birthdate == null) {
        this.formCustomer.birthdate = null;
      } else {
        this.formCustomer.birthdate = Tools.prepareCurrentDate(new Date(customer.birthdate));
      }

      this.formCustomer.phone = customer.phone;
      this.formCustomer.email = customer.email;
      this.formCustomer.district = customer.district;
      this.formCustomer.address = customer.address;
      this.formCustomer.credit_line = customer.credit_line;
      this.formCustomer.discount = customer.discount;

      this.drawer = true;
    },
    updateCustomer() {
      if (!this.existErrors()) {
        let validDocument = this.validateDocumentNumber(this.formCustomer.type, this.formCustomer.document);
        if (validDocument != "success") {
          this.$notify({
            group: "foo",
            type: "error",
            title: "REGISTRO DE CLIENTE",
            text: validDocument,
          });
        } else {
          apiService
            .updateCustomer(this.formCustomer.id, this.formCustomer)
            .then((response) => {
              this.clearForm();
              let index = this.findCustomer(response.data.id);
              this.customers.splice(index, 1, response.data);
              this.$notify({
                group: "foo",
                type: "success",
                title: "ACTUALIZACIÓN DE CLIENTE",
                text: "Cliente fué actualizado de forma correcta.",
              });
              this.drawer = false;
            })
            .catch(function(error) {
              this.$notify({
                group: "foo",
                type: "error",
                title: "ACTUALIZACIÓN DE CLIENTE",
                text: "Ocurrió un error al actualizar cliente.",
              });
            });
        }
      }
    },
    changeStatus(customer, status) {
      let label_status = status;
      let label_name = customer.name;
      if (customer.type_document === "DNI") {
        label_name = label_name + " " + customer.surname;
      }
      this.$swal({
        title: "¿Desea confirmar?",
        text: "Confirma que desea " + label_status + " al cliente: " + label_name,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          if (result.value === true) {
            apiService.changeStatusCustomer(customer.id).then((response) => {
              let index = this.findCustomer(response.data.id);
              this.customers.splice(index, 1, response.data);
              this.$notify({
                group: "foo",
                type: "success",
                title: "ACTUALIZACIÓN DE CLIENTE",
                text: "El estado del cliente fue actualizado de forma correcta.",
              });
            });
          }
        }
      });
    },
    getProducts: function(orderNumber) {
      this.viewProduct = true;
      this.titleProducts = "Productos en orden " + orderNumber;
    },
    handleChangeSelect: function(value) {
      if (this.$refs.formCustomer) {
        this.$refs.formCustomer.clearValidate();
      }
      this.isNatural = true;
      if (value == "Jurídico") {
        this.isNatural = false;
      }
    },
    setIsNatural(type) {
      this.isNatural = true;
      if (type == "Jurídico") {
        this.isNatural = false;
      }
    },
    findCustomer(id) {
      let indexFounded = -1;
      this.customers.findIndex(function(element, index) {
        if (element.id === id) {
          indexFounded = index;
        }
      });
      return indexFounded;
    },
    getStadistic(customer_id = null) {
      ApiCustomer.getSummary(customer_id)
        .then((response) => {
          this.currentStadistic = response.data;
        })
        .catch(function(error) {
          this.$notify({
            group: "foo",
            type: "error",
            title: "ESTADÍSTICAS DE CLIENTE",
            text: "Se detectó un error al obtener estadísticas.",
          });
        });
    },
    getCurrency(amount) {
      let currency = amount.toLocaleString("en-US", {
        style: "currency",
        currency: "PEN",
      });
      currency = currency.replace("PEN", "S/");

      return currency;
    },
    verifyPermission(permission) {
      return this.$hasPermision(permission);
    },
    existErrors() {
      let hasErrors = false;

      Object.keys(this.formCustomer).forEach((f) => {
        if (this.$refs[f]) {
          if (!this.formCustomer[f]) hasErrors = true;
          this.$refs[f].validate(true);
        }
      });

      return hasErrors;
    },
    clearErrors() {
      Object.keys(this.formCustomer).forEach((f) => {
        if (this.$refs[f]) this.$refs[f].reset();
      });
    },
    handleSearchDocument() {
      this.searching_document = true;
      let type_customer = this.formCustomer.type.toLowerCase();
      let document_number = this.formCustomer.document;

      if (type_customer == "natural") {
        APIPERU.consulta_ruc(document_number)
          .then((response) => {
            const { data } = response.data;
            let fechaAux = (data.fecha_nacimiento ?? "").replace("-", "/");
            fechaAux = fechaAux.replace("-", "/");
            var dateParts = fechaAux.split("/");
            var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
            const dd = this.formatDate(dateObject);

            this.searching_document = false;
            this.formCustomer.name = data.nombres;
            this.formCustomer.surname = data.apellido_paterno + " " + data.apellido_materno;
            this.formCustomer.address = data.direccion;
            // this.formCustomer.birthdate = this.formatDate(new Date(response.data.fecha_nacimiento));
            if ((data.fecha_nacimiento ?? "").length > 0) this.formCustomer.birthdate = dd;
            this.formCustomer.district = data.distrito;
            this.formCustomer.gender = "";
          })
          .catch((error) => {
            console.log(error);
            this.searching_document = false;
            this.$notify({
              group: "foo",
              type: "error",
              title: "BÚSQUEDA DE DOCUMENTO",
              text: "Documento no existe.",
            });
          });
      } else if (type_customer == "jurídico") {
        APIPERU.consulta_ruc(document_number)
          .then((response) => {
            const { data } = response.data;
            this.searching_document = false;
            this.formCustomer.name = data.nombre_o_razon_social;
            this.formCustomer.address = data.direccion;
          })
          .catch((error) => {
            console.log(error);
            this.searching_document = false;
            this.$notify({
              group: "foo",
              type: "error",
              title: "BÚSQUEDA DE DOCUMENTO",
              text: "Documento no existe.",
            });
          });
      }
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    validateDocumentNumber(type, document) {
      let message = "success";
      if (type == "Natural") {
        if (document.length != 8) {
          message = "DNI debe tener 8 dígitos";
        }
      } else if (type == "Jurídico") {
        if (document.length != 11) {
          message = "RUC debe tener 11 dígitos";
        }
      }

      return message;
    },
  },
  mounted() {
    this.getStadistic();
    apiService.getCustomers().then((response) => {
      this.customers = null;
      this.customers = response.data;
    });
  },
};
</script>

<style>
.total_drums {
  color: #e53935 !important;
}

.total_balances {
  color: #43a047 !important;
}
</style>
